import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { routes } from './app.routes';
import { CountryService } from './core/country/country.service';
import { ThemeService } from './core/theme/theme.service';
import { trackNavDirection } from './shared/motion/nav-direction';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // La transición entre rutas usa la View Transition nativa del navegador.
    // Donde no existe, la navegación es instantánea: no hay fallback que
    // mantener ni JavaScript de animación que pueda quedarse a medias.
    provideRouter(routes, withViewTransitions()),
    provideClientHydration(withEventReplay()),
    // El catálogo de países se carga antes del primer render: de él sale el hue
    // de marca, así que cargarlo después provocaría un parpadeo de color.
    provideAppInitializer(() => inject(CountryService).load()),
    // El tema se instancia temprano para que el atributo `data-theme` que dejó
    // el script inline de index.html quede bajo control de Angular sin que haya
    // un intervalo en el que nadie lo mantenga.
    provideAppInitializer(() => void inject(ThemeService).theme()),
    provideAppInitializer(() => trackNavDirection()),
  ],
};
